<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="main-card-body">
        <div class="body-header d-flex">
          <div>
            <h4 class="card-header-title" v-if="mData.viewMode == 'create'">
              Thêm mới công ty
            </h4>
            <h4 class="card-header-title" v-if="mData.viewMode == 'detail'">
              Chi tiết công ty
            </h4>
            <h4 class="card-header-title" v-if="mData.viewMode == 'update'">
              Cập nhật công ty
            </h4>
          </div>
          <div class="text-right">
            <el-button
              v-if="mData.viewMode == 'create'"
              round
              @click="fn_submitForm('create')"
              class="btn-default"
              >Thêm mới</el-button
            >

            <el-button
              v-if="mData.viewMode == 'update'"
              round
              @click="fn_submitForm('update')"
              class="btn-default"
              >Cập nhật</el-button
            >

            <el-button round @click="fn_go()" class="btn-default">Quay lại</el-button>
          </div>
        </div>
        <div class="main-body mt-1 scroll-css">
          <el-form
            :model="mData.dataForm"
            :rules="mData.validForm"
            ref="myForm"
            label-width="160px"
            label-position="top"
          >
            <b-row class="mb-3">
              <el-card class="box-card" style="width: 100%">
                <b-row>
                  <div class="md-2">
                    <el-form-item label="Logo" prop="logo_id">
                      <el-upload
                        action
                        :auto-upload="false"
                        list-type="picture-card"
                        :limit="mData.fileUploadOption.Logo.limit"
                        :accept="mData.fileUploadOption.Logo.accept"
                        :on-change="fn_changeLogo"
                        :on-preview="fn_previewLogo"
                        :on-remove="fn_removeLogo"
                        :on-exceed="fn_exceedLogo"
                        :file-list="mData.fileUploadOption.Logo.fileList"
                        :disabled="mData.viewMode == 'detail'"
                        ref="anhDaiDien"
                        :class="[
                          mData.fileUploadOption.Logo.fileList.length > 0
                            ? 'hidden-icon-upload'
                            : '',
                        ]"
                      >
                        <i class="el-icon-plus"></i>
                      </el-upload>
                      <el-dialog
                        :close-on-click-modal="true"
                        :visible.sync="mData.fileUploadOption.Logo.dialogVisible"
                        width="60%"
                        top="51px"
                        title="Chi tiết"
                      >
                        <img
                          width="100%"
                          :src="mData.fileUploadOption.Logo.dialogImageUrl"
                          alt
                        />
                      </el-dialog>
                    </el-form-item>
                  </div>
                  <div class="md-10">
                    <b-row>
                      <b-col lg="4" md="6">
                        <el-form-item label="Tên tiếng Việt" prop="name.name_vi">
                          <el-input
                            @input="forceUpdateUI"
                            type="text"
                            v-model="mData.dataForm.name.name_vi"
                            @change="() => {mData.dataForm.name.name_vi = mData.dataForm.name.name_vi.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Tên tiếng Anh" prop="name.name_en">
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.name.name_en"
                            @change="() => {mData.dataForm.name.name_en = mData.dataForm.name.name_en.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Tên viết tắt" prop="name.abbreviation_name">
                          <el-input
                            @input="forceUpdateUI"
                            v-model.trim="mData.dataForm.name.abbreviation_name"
                            @change="() => {mData.dataForm.name.abbreviation_name = mData.dataForm.name.abbreviation_name.trim().toUpperCase()}"
                            :disabled="mData.viewMode != 'create'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Điện thoại công ty"
                          prop="phone_number.mobile_phone"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.phone_number.mobile_phone"
                            @change="() => {mData.dataForm.phone_number.mobile_phone = mData.dataForm.phone_number.mobile_phone.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Điện thoại cố định"
                          prop="phone_number.phone_number"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.phone_number.phone_number"
                            @change="() => {mData.dataForm.phone_number.phone_number = mData.dataForm.phone_number.phone_number.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Fax"
                          prop="fax"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.fax"
                            @change="() => {mData.dataForm.fax = mData.dataForm.fax.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Mã số thuế"
                          prop="tax_number"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.tax_number"
                            @change="() => {mData.dataForm.tax_number = mData.dataForm.tax_number.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Số đăng ký kinh doanh"
                          prop="business_registration.number"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.business_registration.number"
                            @change="() => {mData.dataForm.business_registration.number = mData.dataForm.business_registration.number.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Ngày cấp"
                          prop="business_registration.issue_date"
                        >
                          <el-date-picker
                            @input="forceUpdateUI"
                            type="date"
                            v-model="mData.dataForm.business_registration.issue_date"
                            :picker-options="pickerOptions"
                            :disabled="mData.viewMode == 'detail'"
                            :clearable="false"
                            placeholder=""
                            prefix-icon="isax-calendar-1"
                            :format="'dd/MM/yyyy'"
                          ></el-date-picker>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Nơi cấp"
                          prop="business_registration.issue_by"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.business_registration.issue_by"
                            @change="() => {mData.dataForm.business_registration.issue_by = mData.dataForm.business_registration.issue_by.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Số tài khoản"
                          prop="bank_account.number"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.bank_account.number"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Tên ngân hàng"
                          prop="bank_account.bank_name"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.bank_account.bank_name"
                            @change="() => {mData.dataForm.bank_account.bank_name = mData.dataForm.bank_account.bank_name.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Tên chi nhánh"
                          prop="bank_account.bank_branch_name"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.bank_account.bank_branch_name"
                            @change="() => {mData.dataForm.bank_account.bank_branch_name = mData.dataForm.bank_account.bank_branch_name.trim()}"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Tổ Chức" prop="organization_type">
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.organization_type"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder="Chọn loại tổ chức"
                            clearable
                          >
                            <el-option
                              v-for="(item, index) in mData.dataDefault.listOrganizationType"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                    </b-row>
                  </div>
                </b-row>
              </el-card>
            </b-row>
            <b-row>
              <el-collapse class="box-card mb-3" v-model="activeName" accordion>
                <el-collapse-item name="address">
                  <template slot="title">
                    <span class="title-card-header">Trụ sở chính</span>
                  </template>
                  <div class="">
                    <b-row>
                      <b-col lg="4" md="6">
                        <el-form-item label="Tỉnh/Thành phố" prop="address.province_id">
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.address.province_id"
                            @change="
                              fn_changeProvince(
                                mData.dataForm.address.province_id,
                                'address'
                              )
                            "
                            :disabled="mData.viewMode == 'detail'"
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listProvinceAddress"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Quận/Huyện" prop="address.district_id">
                          <el-select
                            v-if="loadAddress"
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.address.district_id"
                            :disabled="mData.viewMode == 'detail'"
                            @change="
                              fn_changeDistrict(
                                mData.dataForm.address.district_id,
                                'address'
                              )
                            "
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listDistrictAddress"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Xã/Phường" prop="address.commune_id">
                          <el-select
                            v-if="loadAddressCommune"
                            @input="forceUpdateUI"
                            @change="fn_changeCommune()"
                            v-model="mData.dataForm.address.commune_id"
                            :disabled="mData.viewMode == 'detail'"
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listCommuneAddress"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="12">
                        <el-form-item label="Địa chỉ" prop="address.address">
                          <el-input
                            v-model="mData.dataForm.address.address"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <el-collapse class="box-card mb-3" v-model="activeName1" accordion>
                <el-collapse-item name="representative">
                  <template slot="title">
                    <span class="title-card-header">Người đại diện</span>
                  </template>
                  <div class="">
                    <b-row>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Tên người đại diện"
                          prop="representative.name"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.name"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Giới tính" prop="representative.gender">
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.gender"
                            placeholder="Chọn"
                          >
                            <el-option
                              v-for="(item,index) in mData.dataDefault.listGender"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Chức vụ" prop="representative.position_id">
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.position_id"
                            placeholder="Chọn"
                          >
                            <el-option
                              v-for="(item,index) in mData.dataDefault.listPosition"
                              :key="index"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Email" prop="representative.email">
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.email"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Điện thoại"
                          prop="representative.mobile_phone"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.mobile_phone"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Điện thoại cố định"
                          prop="representative.phone_number"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.phone_number"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Số CMND/CCCD"
                          prop="representative.identity_card"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.identity_card"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="3">
                        <el-form-item
                          label="Mặt trước CMND/CCCD"
                          prop="representative.identity_card_img_before_id"
                        >
                          <el-upload
                            :disabled="mData.viewMode == 'detail'"
                            action
                            drag
                            list-type="text"
                            :auto-upload="false"
                            :limit="
                              mData.fileUploadOption.MatTruocCMNDRepresentative.limit
                            "
                            :accept="
                              mData.fileUploadOption.MatTruocCMNDRepresentative.accept
                            "
                            :on-preview="fn_previewImage"
                            :on-remove="fn_removeMatTruocCMNDRepresentative"
                            :on-change="fn_uploadMatTruocCMNDRepresentative"
                            :file-list="
                              mData.fileUploadOption.MatTruocCMNDRepresentative.fileList
                            "
                            :class="[
                              mData.fileUploadOption.MatTruocCMNDRepresentative.fileList
                                .length > 0
                                ? 'hidden-icon-upload'
                                : '',
                            ]"
                          >
                            <div class="el-upload__text">
                              Kéo file vào đây hoặc <em>click để tải lên</em>
                            </div>
                          </el-upload>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="3">
                        <el-form-item
                          label="Mặt sau CMND/CCCD"
                          prop="representative.identity_card_img_after_id"
                        >
                          <el-upload
                            :disabled="mData.viewMode == 'detail'"
                            action
                            drag
                            list-type="text"
                            :auto-upload="false"
                            :limit="mData.fileUploadOption.MatSauCMNDRepresentative.limit"
                            :accept="
                              mData.fileUploadOption.MatSauCMNDRepresentative.accept
                            "
                            :on-preview="fn_previewImage"
                            :on-remove="fn_removeMatSauCMNDRepresentative"
                            :on-change="fn_uploadMatSauCMNDRepresentative"
                            :file-list="
                              mData.fileUploadOption.MatSauCMNDRepresentative.fileList
                            "
                            :class="[
                              mData.fileUploadOption.MatSauCMNDRepresentative.fileList
                                .length > 0
                                ? 'hidden-icon-upload'
                                : '',
                            ]"
                          >
                            <div class="el-upload__text">
                              Kéo file vào đây hoặc <em>click để tải lên</em>
                            </div>
                          </el-upload>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Tỉnh/Thành phố"
                          prop="representative.address.province_id"
                        >
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.address.province_id"
                            :disabled="mData.viewMode == 'detail'"
                            @change="
                              fn_changeProvince(
                                mData.dataForm.representative.address.province_id,
                                'representative'
                              )
                            "
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listProvinceRepresentative"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Quận/Huyện"
                          prop="representative.address.district_id"
                        >
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.address.district_id"
                            :disabled="mData.viewMode == 'detail'"
                            @change="
                              fn_changeDistrict(
                                mData.dataForm.representative.address.district_id,
                                'representative'
                              )
                            "
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listDistrictRepresentative"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Xã/Phường"
                          prop="representative.address.commune_id"
                        >
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.address.commune_id"
                            :disabled="mData.viewMode == 'detail'"
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listCommuneRepresentative"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="12">
                        <el-form-item
                          label="Địa chỉ"
                          prop="representative.address.address"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.representative.address.address"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
              <el-collapse class="box-card mb-3" v-model="activeName2" accordion>
                <el-collapse-item name="contact">
                  <template slot="title">
                    <span class="title-card-header">Người liên hệ</span>
                  </template>
                  <div class="">
                    <b-row>
                      <b-col md="6">
                        <el-form-item label="Tên người liên hệ" prop="contact.name">
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.name"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="Email" prop="contact.email">
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.email"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item label="Điện thoại" prop="contact.mobile_phone">
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.mobile_phone"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col md="6">
                        <el-form-item
                          label="Điện thoại cố định"
                          prop="contact.phone_number"
                        >
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.phone_number"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                    <b-row>
                      <b-col lg="4" md="6">
                        <el-form-item label="Số CMND/CCCD" prop="contact.identity_card">
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.identity_card"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="3">
                        <el-form-item
                          label="Mặt trước CMND/CCCD"
                          prop="contact.identity_card_img_before_id"
                        >
                          <el-upload
                            :disabled="mData.viewMode == 'detail'"
                            action
                            drag
                            list-type="text"
                            :auto-upload="false"
                            :limit="mData.fileUploadOption.MatTruocCMNDContact.limit"
                            :accept="mData.fileUploadOption.MatTruocCMNDContact.accept"
                            :on-preview="fn_previewImage"
                            :on-remove="fn_removeMatTruocCMNDContact"
                            :on-change="fn_uploadMatTruocCMNDContact"
                            :file-list="
                              mData.fileUploadOption.MatTruocCMNDContact.fileList
                            "
                            :class="[
                              mData.fileUploadOption.MatTruocCMNDContact.fileList.length >
                              0
                                ? 'hidden-icon-upload'
                                : '',
                            ]"
                          >
                            <div class="el-upload__text">
                              Kéo file vào đây hoặc <em>click để tải lên</em>
                            </div>
                          </el-upload>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="3">
                        <el-form-item
                          label="Mặt sau CMND/CCCD"
                          prop="contact.identity_card_img_after_id"
                        >
                          <el-upload
                            :disabled="mData.viewMode == 'detail'"
                            action
                            drag
                            list-type="text"
                            :auto-upload="false"
                            :limit="mData.fileUploadOption.MatSauCMNDContact.limit"
                            :accept="mData.fileUploadOption.MatSauCMNDContact.accept"
                            :on-preview="fn_previewImage"
                            :on-remove="fn_removeMatSauCMNDContact"
                            :on-change="fn_uploadMatSauCMNDContact"
                            :file-list="mData.fileUploadOption.MatSauCMNDContact.fileList"
                            :class="[
                              mData.fileUploadOption.MatSauCMNDContact.fileList.length > 0
                                ? 'hidden-icon-upload'
                                : '',
                            ]"
                          >
                            <div class="el-upload__text">
                              Kéo file vào đây hoặc <em>click để tải lên</em>
                            </div>
                          </el-upload>
                        </el-form-item>
                      </b-col>
                      <!-- <b-col lg="8" md="6" class="d-flex at-center" v-if="mData.viewMode != 'detail'">
                                                <p class="mt-3">(Tải ảnh mặt trước, mặt sau)</p>
                                            </b-col> -->
                    </b-row>
                    <b-row>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Tỉnh/Thành phố"
                          prop="contact.address.province_id"
                        >
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.address.province_id"
                            :disabled="mData.viewMode == 'detail'"
                            @change="
                              fn_changeProvince(
                                mData.dataForm.contact.address.province_id,
                                'contact'
                              )
                            "
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listProvinceContact"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item
                          label="Quận/Huyện"
                          prop="contact.address.district_id"
                        >
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.address.district_id"
                            :disabled="mData.viewMode == 'detail'"
                            @change="
                              fn_changeDistrict(
                                mData.dataForm.contact.address.district_id,
                                'contact'
                              )
                            "
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listDistrictContact"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col lg="4" md="6">
                        <el-form-item label="Xã/Phường" prop="contact.address.commune_id">
                          <el-select
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.address.commune_id"
                            :disabled="mData.viewMode == 'detail'"
                            clearable
                            filterable
                          >
                            <el-option
                              v-for="item in mData.dataDefault.listCommuneContact"
                              :key="item.id"
                              :label="item.name"
                              :value="item.id"
                            ></el-option>
                          </el-select>
                        </el-form-item>
                      </b-col>
                      <b-col md="12">
                        <el-form-item label="Địa chỉ" prop="contact.address.address">
                          <el-input
                            @input="forceUpdateUI"
                            v-model="mData.dataForm.contact.address.address"
                            :disabled="mData.viewMode == 'detail'"
                            placeholder=""
                          ></el-input>
                        </el-form-item>
                      </b-col>
                    </b-row>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </b-row>
          </el-form>
        </div>
      </div>
    </div>
    <el-dialog
      width="50%"
      top="30px"
      title="Chi tiết"
      :close-on-click-modal="true"
      :visible.sync="mData.Anh.dialogVisible"
      :before-close="closeDialogImage"
    >
      <img class="dialog-image" width="100%" :src="mData.Anh.dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import ValidService from "../../../service/ValidService";
import MethodService from "../../../service/MethodService";
import ExtensionService from "../../../service/ExtensionService";
import CompanyApi from "../../../moduleApi/CompanyApi";
import DistrictApi from "../../../moduleApi/DistrictApi";
import CommuneApi from "../../../moduleApi/CommuneApi";
import ProvinceApi from "../../../moduleApi/ProvinceApi";
import PositionApi from '../../../moduleApi/PositionApi';
import ProfileApi from "../../../moduleApi/ProfileApi";
import CompanyModel from "./CompanyModel";

export default {
  data() {
    return {
      loadAddress: true,
      loadAddressCommune: true,
      activeName: "address",
      activeName1: "representative",
      activeName2: "contact",
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() >= new Date().getTime();
        },
      },
      mData: {
        viewMode: "create",
        data: [],
        moduleName: "Company", //requied
        dataForm: MethodService.copyObject(CompanyModel.dataForm),
        validForm: CompanyModel.validForm,
        tableRules: MethodService.copyObject(CompanyModel.tableRules),
        fileUploadOption: MethodService.copyObject(
          CompanyModel.dataFormOther.fileUploadOption
        ),
        dataDefault: {
          listGender: CompanyModel.listGender,
          listOrganizationType: CompanyModel.listOrganizationType,
          listCompanyType: CompanyModel.listCompanyType,
          listParentCompany: [],
          listPosition: [],
          listProvince: [],
          listDistrict: [],
          listCommune: [],
          listProvinceAddress: [],
          listDistrictAddress: [],
          listCommuneAddress: [],
          listProvinceRepresentative: [],
          listDistrictRepresentative: [],
          listCommuneRepresentative: [],
          listProvinceContact: [],
          listDistrictContact: [],
          listCommuneContact: [],
        },
        Anh: {
          dialogVisible: false,
          dialogImageUrl: "",
        },
      },
    };
  },

  methods: {
    async fn_initDataDefault() {
      const provinceApiReq = await ProvinceApi.list({ limit: 1000 });
      const positionApiReq = await PositionApi.list({
        filters: `company_id:is_null:true`,
        limit: 100
      });
      const provinceApiRes = await provinceApiReq;
      const positionApiRes = await positionApiReq;
      const companyApiRes = await CompanyApi.list({
        filters: "disabled=false",
        limit: 100000
      }, true);
      this.mData.dataDefault.listProvince = provinceApiRes.result;
      this.mData.dataDefault.listPosition = positionApiRes.result;
      this.mData.dataDefault.listParentCompany = (companyApiRes.result || []).filter((item) => {
        return ["GROUP", "CORPORATION"].includes(item.company_type);
      });
      this.mData.dataDefault.listProvince.forEach((item) => {
        if (item.type == "Thành phố") {
          item.name = "Thành phố " + item.name;
        }
      });
      this.mData.dataDefault.listProvinceAddress = this.mData.dataDefault.listProvince;
      this.mData.dataDefault.listProvinceRepresentative = this.mData.dataDefault.listProvince;
      this.mData.dataDefault.listProvinceContact = this.mData.dataDefault.listProvince;
    },
    fn_parentCompanyOptions() {
      return (this.mData.dataDefault.listParentCompany || []).filter((item) => {
        return item.id !== this.mData.dataForm.id;
      });
    },
    fn_companyOptionLabel(item) {
      if (!item) return "";
      const name = item.name && (item.name.name_vi || item.name.abbreviation_name || item.name.name_en);
      const type = this.mData.dataDefault.listCompanyType.find((option) => option.value === item.company_type);
      return `${name || item.id}${type ? " - " + type.label : ""}`;
    },
    async fn_getDataById(id) {
      let res = await CompanyApi.findById(id);
      if (res.result) {
        if (!res.result.business_registration) {
          res.result.business_registration = {};
        }
        if (!res.result.bank_account) {
          res.result.bank_account = {};
        }
        if (!res.result.company_type) {
          res.result.company_type = "COMPANY";
        }
        this.mData.dataForm = res.result;
        if (res.result && res.result.logo_id) {
          let data = {
            id: res.result.logo_id,
            name: res.result.logo_id,
            url: ExtensionService.urlImg + res.result.logo_id,
          };
          this.mData.fileUploadOption.Logo.fileList.push(data);
        }
        if (res.result.address) {
          if (res.result.address.province_id) {
            let resAdressDistrict = await DistrictApi.list({
              limit: 100,
              filters: "province_id=" + res.result.address.province_id,
            });
            this.mData.dataDefault.listDistrictAddress = resAdressDistrict.result;
          }

          if (res.result.address.district_id) {
            let resAdressCommune = await CommuneApi.list({
              limit: 100,
              filters: "district_id=" + res.result.address.district_id,
            });
            this.mData.dataDefault.listCommuneAddress = resAdressCommune.result;
          }
        }
        if (res.result.representative && res.result.representative.address) {
          if (res.result.representative.address.province_id) {
            let resRepresentativesAdressDistrict = await DistrictApi.list({
              limit: 100,
              filters: "province_id=" + res.result.representative.address.province_id,
            });
            this.mData.dataDefault.listDistrictRepresentative =
              resRepresentativesAdressDistrict.result;
          }

          if (res.result.representative.address.district_id) {
            let resRepresentativesAdressCommune = await CommuneApi.list({
              limit: 100,
              filters: "district_id=" + res.result.representative.address.district_id,
            });
            this.mData.dataDefault.listCommuneRepresentative =
              resRepresentativesAdressCommune.result;
          }
        }
        if (res.result.contact && res.result.contact.address) {
          if (res.result.contact.address.province_id) {
            let resContactAdressDistrict = await DistrictApi.list({
              limit: 100,
              filters: "province_id=" + res.result.contact.address.province_id,
            });
            this.mData.dataDefault.listDistrictContact = resContactAdressDistrict.result;
          }

          if (res.result.contact.address.district_id) {
            let resContactAdressCommune = await CommuneApi.list({
              limit: 100,
              filters: "district_id=" + res.result.contact.address.district_id,
            });
            this.mData.dataDefault.listCommuneContact = resContactAdressCommune.result;
          }
        }
        if (this.mData.dataForm.representative.identity_card_img_before_id) {
          let data = {
            id: this.mData.dataForm.representative.identity_card_img_before_id,
            name: "MatTruocCMCDNguoiDaiDien",
            url:
              ExtensionService.urlImg +
              this.mData.dataForm.representative.identity_card_img_before_id,
          };
          this.mData.fileUploadOption.MatTruocCMNDRepresentative.fileList.push(data);
        }
        if (this.mData.dataForm.representative.identity_card_img_after_id) {
          let data = {
            id: this.mData.dataForm.representative.identity_card_img_after_id,
            name: "MatSauCMCDNguoiDaiDien",
            url:
              ExtensionService.urlImg +
              this.mData.dataForm.representative.identity_card_img_after_id,
          };
          this.mData.fileUploadOption.MatSauCMNDRepresentative.fileList.push(data);
        }
        if (this.mData.dataForm.contact.identity_card_img_before_id) {
          let data = {
            id: this.mData.dataForm.contact.identity_card_img_before_id,
            name: "MatTruocCMCDNguoiLienHe",
            url:
              ExtensionService.urlImg +
              this.mData.dataForm.contact.identity_card_img_before_id,
          };
          this.mData.fileUploadOption.MatTruocCMNDContact.fileList.push(data);
        }
        if (this.mData.dataForm.contact.identity_card_img_after_id) {
          let data = {
            id: this.mData.dataForm.contact.identity_card_img_after_id,
            name: "MatSauCMCDNguoLienHe",
            url:
              ExtensionService.urlImg +
              this.mData.dataForm.contact.identity_card_img_after_id,
          };
          this.mData.fileUploadOption.MatSauCMNDContact.fileList.push(data);
        }
      }
    },
    fn_submitForm(type) {
      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          let data = this.mData.dataForm;
          data.company_type = "COMPANY";
          const currentCompany = MethodService.getCompanyInfo();
          data.parent_company_id = currentCompany && currentCompany.id ? currentCompany.id : null;
          let dataProfile = {
            id: this.mData.dataForm.id,
            name: {
              full_name: this.mData.dataForm.name.name_vi,
            },
            phone_number: this.mData.dataForm.phone_number.phone_number,
            email: this.mData.dataForm.contact.email,
          };
          let province = this.mData.dataDefault.listProvince.find((item) => {
            return item.id == this.mData.dataForm.address.province_id;
          });
          data.address.province_name = province.name;
          let district = this.mData.dataDefault.listDistrictAddress.find((item) => {
            return item.id == this.mData.dataForm.address.district_id;
          });
          data.address.district_name = district.name;
          let commune = this.mData.dataDefault.listCommuneAddress.find((item) => {
            return item.id == this.mData.dataForm.address.commune_id;
          });
          data.address.commune_name = commune.name;

          try {
            if (type == "create") {
              if (MethodService.checkHaveFeature("FT2302") &&
                currentCompany && currentCompany.id
            ) {
                data.parent_company_id = MethodService.getCompanyInfo().id ;
              }
              await CompanyApi.create(data);
              window.toastr.success("Thêm mới công ty thành công");
              this.fn_go();
            } else if (type == "update") {
              data.id = this.$router.currentRoute.params.id;
              await CompanyApi.update(data);
              await ProfileApi.update(dataProfile);
              window.toastr.success("Cập nhật công ty thành công");
              this.fn_go();
            }
          } catch (error) {
            if (error && error.code && error.code == 500) {
              window.toastr.error(
                `Đã tồn tại công ty có tên viết tắt "${this.mData.dataForm.name.abbreviation_name}"`
              );
            } else {
              if (type == "create") {
                window.toastr.error("Thêm mới công ty không thành công");
              } else if (type == "update") {
                window.toastr.error("Cập nhật công ty không thành công");
              }
            }
          }
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetOneFiled(field) {
      this.$refs["myForm"].fields.find((f) => f.prop == field).resetField();
    },
    async fn_changeProvince(provinceId, type) {
      this.loadAddress = false;
      let districtApiRes = await DistrictApi.list({
        limit: 100,
        filters: "province_id=" + provinceId,
      });
      if (type == "address") {
        this.fn_resetOneFiled("address.district_id");
        this.fn_resetOneFiled("address.commune_id");
        this.mData.dataDefault.listCommuneAddress = [];
        this.mData.dataDefault.listDistrictAddress = districtApiRes.result;
      }
      if (type == "representative") {
        this.fn_resetOneFiled("representative.address.district_id");
        this.fn_resetOneFiled("representative.address.commune_id");
        this.mData.dataDefault.listCommuneRepresentative = [];
        this.mData.dataDefault.listDistrictRepresentative = districtApiRes.result;
      }
      if (type == "contact") {
        this.fn_resetOneFiled("contact.address.district_id");
        this.fn_resetOneFiled("contact.address.commune_id");
        this.mData.dataDefault.listCommuneContact = [];
        this.mData.dataDefault.listDistrictContact = districtApiRes.result;
      }
      this.loadAddress = true;
    },
    async fn_changeDistrict(districtId, type) {
      this.forceUpdateUI();
      this.loadAddress = false;
      this.loadAddressCommune = false;
      let communeApiRes = await CommuneApi.list({
        limit: 100,
        filters: "district_id=" + districtId,
      });
      if (type == "address") {
        // if(this.mData.dataForm.address.district_id){
        //     this.$refs['myForm'].fields.find((f) => f.prop == "address.district_id").clearValidate();
        // }
        this.fn_resetOneFiled("address.commune_id");
        this.mData.dataDefault.listCommuneAddress = communeApiRes.result;
      }
      if (type == "representative") {
        this.fn_resetOneFiled("representative.address.commune_id");
        this.mData.dataDefault.listCommuneRepresentative = communeApiRes.result;
      }
      if (type == "contact") {
        this.fn_resetOneFiled("contact.address.commune_id");
        this.mData.dataDefault.listCommuneContact = communeApiRes.result;
      }
      this.loadAddress = true;
      this.loadAddressCommune = true;
    },
    fn_changeCommune() {
      this.loadAddressCommune = false;
      setTimeout(() => {
        this.loadAddressCommune = true;
      }, 10);

      // this.forceUpdateUI()
      // if(this.mData.dataForm.address.commune_id){
      //     // this.$refs['myForm'].fields.find((f) => f.prop == "address.commune_id").clearValidate();
      //     // this.$refs["myForm"].fi.clearValidate('address.commune_id');
      //     // this.fn_resetOneFiled("address.commune_id");
      //     this.mData.validForm.address.commune_id = [ValidService.requiredNoMessage];
      // }
    },
    //upload File
    fn_removeMatTruocCMNDRepresentative() {
      this.mData.dataForm.representative.identity_card_img_before_id = null;
      this.mData.fileUploadOption.MatTruocCMNDRepresentative.fileList = [];
    },
    fn_removeMatSauCMNDRepresentative() {
      this.mData.dataForm.representative.identity_card_img_after_id = null;
      this.mData.fileUploadOption.MatSauCMNDRepresentative.fileList = [];
    },
    fn_removeMatTruocCMNDContact() {
      this.mData.dataForm.contact.identity_card_img_before_id = null;
      this.mData.fileUploadOption.MatTruocCMNDContact.fileList = [];
    },
    fn_removeMatSauCMNDContact() {
      this.mData.dataForm.contact.identity_card_img_after_id = null;
      this.mData.fileUploadOption.MatSauCMNDContact.fileList = [];
    },
    async fn_uploadMatTruocCMNDRepresentative(file, fileList) {
      file.name = "MatTruocCMCDNguoiDaiDien";
      ExtensionService.upload(file, "MatTruocCMCDNguoiDaiDien")
        .then((res) => {
          this.mData.dataForm.representative.identity_card_img_before_id = res.result;
          let data = {
            id: res.result,
            name: "MatTruocCMCDNguoiDaiDien",
            url: ExtensionService.urlImg + res.result,
          };
          this.mData.fileUploadOption.MatTruocCMNDRepresentative.fileList.push(data);
        })
        .catch((error) => {
          window.toastr.error("Có lỗi xảy ra, vui lòng thử lại!");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    async fn_uploadMatSauCMNDRepresentative(file, fileList) {
      file.name = "MatSauCMCDNguoiDaiDien";
      ExtensionService.upload(file, "MatSauCMCDNguoiDaiDien")
        .then((res) => {
          this.mData.dataForm.representative.identity_card_img_after_id = res.result;
          let data = {
            id: res.result,
            name: "MatSauCMCDNguoiDaiDien",
            url: ExtensionService.urlImg + res.result,
          };
          this.mData.fileUploadOption.MatSauCMNDRepresentative.fileList.push(data);
          // this.mData.fileUploadOption.MatSauCMNDRepresentative.fileList = fileList;
        })
        .catch((error) => {
          window.toastr.error("Có lỗi xảy ra, vui lòng thử lại!");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    async fn_uploadMatTruocCMNDContact(file, fileList) {
      file.name = "MatTruocCMCDNguoiLienHe";
      ExtensionService.upload(file, "MatTruocCMCDNguoiLienHe")
        .then((res) => {
          this.mData.dataForm.contact.identity_card_img_before_id = res.result;
          let data = {
            id: res.result,
            name: "MatTruocCMCDNguoiLienHe",
            url: ExtensionService.urlImg + res.result,
          };
          this.mData.fileUploadOption.MatTruocCMNDContact.fileList.push(data);
          // this.mData.fileUploadOption.MatTruocCMNDContact.fileList = fileList;
        })
        .catch((error) => {
          window.toastr.error("Có lỗi xảy ra, vui lòng thử lại!");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    async fn_uploadMatSauCMNDContact(file, fileList) {
      file.name = "MatSauCMCDNguoLienHe";
      ExtensionService.upload(file, "MatSauCMCDNguoLienHe")
        .then((res) => {
          this.mData.dataForm.contact.identity_card_img_after_id = res.result;
          let data = {
            id: res.result,
            name: "MatSauCMCDNguoLienHe",
            url: ExtensionService.urlImg + res.result,
          };
          this.mData.fileUploadOption.MatSauCMNDContact.fileList.push(data);
          // this.mData.fileUploadOption.MatSauCMNDContact.fileList = fileList;
        })
        .catch((error) => {
          window.toastr.error("Có lỗi xảy ra, vui lòng thử lại!");
          fileList.forEach((el, i) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_uploadExceedFile() {
      window.toastr.info(`Chỉ tải lên tối đa 1 file!`);
    },
    fn_previewImage(file) {
      this.mData.Anh.dialogImageUrl = file.url;
      this.mData.Anh.dialogVisible = true;
    },
    //Logo
    fn_removeLogo(file, fileList) {
      this.mData.dataForm.logo_id = null;
      this.mData.fileUploadOption.Logo.fileList = [];
    },
    fn_changeLogo(file, fileList) {
      ExtensionService.upload(file, "tinTuc")
        .then((res) => {
          this.mData.dataForm.logo_id = res.result;
          this.mData.fileUploadOption.Logo.fileList = fileList;
        })
        .catch((error) => {
          $.each(fileList, (i, el) => {
            if (el.uid == file.uid) {
              fileList.splice(i, 1);
            }
          });
        });
    },
    fn_exceedLogo(files, fileList) {
      toastr.info(`Chỉ tải lên tối đa ${this.mData.fileUploadOption.Logo.limit} file`);
    },
    fn_previewLogo(file) {
      this.mData.fileUploadOption.Logo.dialogImageUrl = file.url;
      this.mData.fileUploadOption.Logo.dialogVisible = true;
    },
    fn_go() {
      this.$router.go(-1);
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    closeDialogImage() {
      this.mData.Anh.dialogVisible = false;
      this.mData.Anh.dialogImageUrl = "";
    },
  },

  //run after render view
  created() {
    this.mData.validForm.phone_number.mobile_phone.push(
      ValidService.checkNumber,
      ValidService.checkPhone
    );

    this.fn_initDataDefault();
    if (this.$router.currentRoute.name == "Admin-" + this.mData.moduleName + "-create") {
      this.mData.viewMode = "create";
    }
    if (this.$router.currentRoute.name == "Admin-" + this.mData.moduleName + "-update") {
      this.mData.viewMode = "update";
    }
    if (this.$router.currentRoute.name == "Admin-" + this.mData.moduleName + "-detail") {
      this.mData.viewMode = "detail";
    }

    if (this.$router.currentRoute.name == "Admin-CompanyInfo-detail") {
      this.mData.viewMode = "detail";
    }
    if (this.$router.currentRoute.params.id) {
      this.fn_getDataById(this.$router.currentRoute.params.id);
    }
  },
  mounted() {},
};
</script>

<style scoped>
::v-deep .el-dialog__body {
  max-height: calc(100vh - 145px);
  overflow: auto;
}
::v-deep .el-collapse {
  width: 100%;
  border: 1px solid #ebeef5;
  background-color: #fff;
  color: #303133;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
}
::v-deep .el-collapse-item__header {
  background-color: #fff !important;
  border-radius: 4px;
}
::v-deep .el-upload-list__item {
  transition: none !important;
}
::v-deep .el-upload-dragger {
  height: 35px;
}
.dialog-image {
  max-height: calc(100vh - 158px);
}
.md-2 {
  width: 13%;
}
.md-10 {
  width: 87%;
}
@media (max-width: 1445px) and (min-width: 1161px) {
  .md-2 {
    width: 18%;
  }
  .md-10 {
    width: 82%;
  }
}
@media (max-width: 1160px) and (min-width: 851px) {
  .md-2 {
    width: 20%;
  }
  .md-10 {
    width: 80%;
  }
}
@media (max-width: 850px) and (min-width: 768px) {
  .md-2 {
    width: 22%;
  }
  .md-10 {
    width: 78%;
  }
}
@media (max-width: 767px) {
  .md-2 {
    width: 100%;
  }
  .md-10 {
    width: 100%;
  }
}
</style>
